import { Box, colors } from '@factorialco/deprecated-design-system'
import { isEmpty } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import Item from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/TimeBreakdown/components/Item'
import { Contribution } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/lib/breakdownWorkedTime'

import Section from './components/Section'

interface PaidBreaksProps {
  breaksMinutes: number
  breaksContributions: Contribution[]
}

const PaidBreaks = ({ breaksMinutes, breaksContributions }: PaidBreaksProps) => {
  return (
    <Section
      title={i18n.t('clock_in.sidepanel.accordion.paid_breaks.title')}
      minutes={breaksMinutes}
      circleColor={colors.tangerine1000}
    >
      {!isEmpty(breaksContributions) && (
        <Box paddingLeft="s16">
          {breaksContributions.map(({ name, minutes }) => (
            <Item key={name} label={name} minutes={minutes} />
          ))}
        </Box>
      )}
    </Section>
  )
}

export default PaidBreaks
